import UserModalBase from './UserModalBase';
import CommonUserFields from './fields/CommonUserFields';
import PasswordFields from './fields/PasswordFields';
import UsernameAvailabilityField from './fields/UsernameAvailabilityField';
import { validateCreateUserForm } from '../../utils/userValidation';

const EMPTY_FORM = {
  username: '',
  password: '',
  confirmPassword: '',
  displayName: '',
  emailAddress: '',
  agencyName: '',
  userType: 10,
};

const CreateUserModal = ({ show, userTypes, onSubmit, onClose }) => (
  <UserModalBase
    show={show}
    title="Create New User"
    initialValues={EMPTY_FORM}
    validate={validateCreateUserForm}
    submitLabel="Create User"
    loadingLabel="Creating..."
    onSubmit={({ confirmPassword, ...form }) =>
      onSubmit({
        ...form,
        userType: Number(form.userType),
      })
    }
    onClose={onClose}
  >
    {({ formData, handleChange }) => (
      <>
        <UsernameAvailabilityField
          formData={formData}
          onChange={handleChange}
        />
        <CommonUserFields
          formData={formData}
          onChange={handleChange}
          userTypes={userTypes}
        />
        <PasswordFields
          formData={formData}
          onChange={handleChange}
        />
      </>
    )}
  </UserModalBase>
);

export default CreateUserModal;
